import { Color } from './radix';

export type ActionItem = { id: string };

export interface ActionsProps<T extends ActionItem> {
    actions: Action<T>[];
    selectedItems: T[];
}

export interface Action<T extends ActionItem = ActionItem> {
    label: string | ((items: T[]) => string);
    icon?: React.ReactNode | ((items: T[]) => React.ReactNode);
    color?: Color | ((items: T[]) => Color);
    onClick: (items: T[]) => void;
    hidden?: (items: T[]) => boolean;
}

export const asFunction = <T, V>(value: V | ((items: T[]) => V)) => {
    return typeof value === 'function'
        ? (value as (items: T[]) => V)
        : () => value;
};

export const createActions = <T extends ActionItem>(
    actions: Action<T>[],
): Action<T>[] => actions;
